import { BasePlugin } from '@uppy/core';

class GitlUploader extends BasePlugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = opts.id || 'GitlUploader';
    this.type = 'uploader';
    // admin-sdk client
    this.client = opts.client;
    this.businessId = opts.businessId;
  }

  async doUpload(file) {
    const client = this.client;

    const id = await client
      .businesses.for(this.businessId)
      .social.media
      .create({
        file: file.data,
        mediaType: 'reel',
        mimeType: file.meta.type,
        width: file.meta.width,
        height: file.meta.height,
        size: file.meta.fileSize,
        duration: file.meta.duration,
      });

    return {
      imageRefId: id,
    };
  }

  upload = (fileIDs) => {
    // emit the event for progress tracking to uppy
    this.uppy.emit('upload-start', this.uppy.getFiles());

    const promises = fileIDs.map((fileId) => {
      const file = this.uppy.getFile(fileId);

      return new Promise((resolve, rejects) => {
        // some upload hook
        this.doUpload(file)
          .then((result) => {
            // event emitting is important for uppy to keep track of the actual progress state
            this.uppy.emit('upload-success', file, result);
            resolve(result);
          })
          .catch((err) => {
            // event emitting is important for uppy to keep track of the actual progress state
            this.uppy.emit('upload-error', file, err);
            rejects(err);
          });
      });
    });

    return Promise.all(promises).then(() => {}); // returned promise needs to be Promise<void>
  };

  install() {
    this.uppy.addUploader(this.upload);
  }

  uninstall() {
    this.uppy.removeUploader(this.upload);
  }
}

export default GitlUploader;
